import React from "react";
import { useLocation } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import theme from "../../theme";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import DashboardHeader from "./DashboardHeader";
import Reservations from "./Reservations";
import KitchenListings from "./KitchenListings";
import Calendar from "./Calendar";
import { Box, Typography } from "@mui/material";
import "./DashboardHub.css";

const DashboardHub = () => {
  const location = useLocation();
  const currentPath = location.pathname;

  return (
    <ThemeProvider theme={theme}>
      <div className="dashboard-page">
        <Navbar />
        <Box className="dashboard-hub" sx={{ bgcolor: "#ffffff" }}>
          <DashboardHeader />
          {currentPath === "/dashboard/today" && <Reservations />}
          {currentPath === "/dashboard/my-listings" && <KitchenListings />}
          {currentPath === "/dashboard/calendar" && <Calendar />}
          {["/dashboard/messages", "/dashboard/menu"].includes(currentPath) && (
            <Box sx={{ py: 8, textAlign: "center" }}>
              <Typography variant="h4" color="text.primary">
                Coming Soon
              </Typography>
            </Box>
          )}
        </Box>
        <Footer />
      </div>
    </ThemeProvider>
  );
};

export default DashboardHub;
